import Link from 'next/link'

export default function MyLink({ children, prefetch = false, ...otherProps }) {
  // defaults prefetch to false if `prefetch` is not true
  return <Link {...otherProps} prefetch={prefetch}>{children}</Link>
}